import { Box, Button, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    color: '#fff',
    borderRadius: '5px',
    margin: '0',
    fontWeight: 500,
    letterSpacing: 0.5,
    lineHeight: 1,
    padding: '12px 15px',
  },
  buttonContainer: {
    width: '100%',
    textAlign: 'center',
    fontFamily: 'titillium-semibold',
    fontSize: '15px',
  },
  cancelButton: {
    borderRadius: 0,
    marginTop: 0,
    color: theme.palette.custom.lightBlack,
    textDecoration: `underline solid ${theme.palette.primary.light} 2px`,
    textUnderlineOffset: '3px',
    borderBottom: 'none',
    cursor: 'pointer',
  },
  saveButton: {
    marginTop: 0,
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.custom.darkRed} inset`,
      color: theme.palette.custom.lightBlack,
      background: theme.palette.custom.white,
    },
  },
}));

const StripeChangeCardButtonAction = ({
  cancelHandler,
  saveLabel,
  cancelLabel,
  name,
  saveButtonId,
  saveHandler,
}) => {
  const buttonActionClasses = useStyles();
  return (
    <Box mt={5}>
      <Box display="flex" justifyContent="flex-end" flexDirection="column">
        <Box>
          <Box className={buttonActionClasses.buttonContainer}>
            <Button
              className={`${buttonActionClasses.button} ${buttonActionClasses.saveButton}`}
              id={saveButtonId}
              onClick={saveHandler}
              data-testid={`stripe-button-save-${name}`}
            >
              {saveLabel}
            </Button>
          </Box>
          <Box className={buttonActionClasses.buttonContainer} mt={6}>
            <Link
              size="small"
              className={`${buttonActionClasses.button} ${buttonActionClasses.cancelButton}`}
              data-testid={`stripe-button-cancel-${name}`}
              onClick={() => {
                cancelHandler();
              }}
            >
              {cancelLabel}
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StripeChangeCardButtonAction;
